import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, Observable, of, switchMap } from 'rxjs';
import { Action } from '@ngrx/store';
import {
  CallCentreStatusActions,
  CallCentreStatusAPIActions,
} from '../actions/call-centre-status.actions';
import { ComplianceHttpService } from '../../http/compliance/compliance-http.service';

@Injectable()
export class CallCentreStatusEffects {
  public loadCallCentreStatus$: Observable<Action> = createEffect(() =>
    this._actions$.pipe(
      ofType(CallCentreStatusActions.loadCallCentreStatus),
      switchMap(() =>
        this._complianceHttpService.callCentreStatus$.pipe(
          mergeMap((callCentreStatus) =>
            of(
              CallCentreStatusAPIActions.loadedCallCentreStatusSuccessfully({
                callCentreStatus,
              }),
            ),
          ),
          catchError((error) =>
            of(
              CallCentreStatusAPIActions.loadedCallCentreStatusUnsuccessfully({
                error,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private _actions$: Actions,
    private _complianceHttpService: ComplianceHttpService,
  ) {}
}
